/**
 * Base units for products — values must match GraphQL `BaseUnit` and the
 * products-and-category service enum (wire format is the enum name, e.g. `L`, `SQCM`).
 */
export enum Unit {
  UNIT = "UNIT",
  KG = "KG",
  G = "G",
  L = "L",
  ML = "ML",
  M = "M",
  CM = "CM",
  MM = "MM",
  SQCM = "SQCM",
  OZ = "OZ",
  LB = "LB",
  BOTTLE = "BOTTLE"
}

export enum UnitSystem {
  METRIC = "METRIC",
  IMPERIAL = "IMPERIAL"
}

export enum MeasureType {
  COUNT = "COUNT",
  WEIGHT = "WEIGHT",
  VOLUME = "VOLUME",
  LENGTH = "LENGTH",
  AREA = "AREA"
}
